import React, { useState, useEffect, useMemo } from "react";
import services from "@/services";
import utils from "@/utils/utils";
import style from "./style.module.scss";
import { base } from "@/services/api/_base";
import useThrottle from "@/utils/useThrottle";
const { apis } = services;
const tabs = ["前言资讯", "品牌新闻"];

export default function News(props: any) {
  const { brandId } = props || {};
  const [currentTab, setCurrentTab] = useState(0);
  const [informationList, setInformationList]: any = useState([]); // 前沿资讯数据
  const [informationPageIndex, setInformationPageIndex]: any = useState(0); // 前沿资讯当前页码
  const [searchAfter, setSearchAfter] = useState(""); // 前沿资讯下一页标识
  const [newsList, setNewsList]: any = useState([]); // 品牌新闻数据
  const [newsPageIndex, setNewsPageIndex]: any = useState(0); // 品牌新闻当前页码

  // 获取前言资讯数据
  const getInformationList = async () => {
    const params: any = {
      appid: "app",
      page_size: 5,
      brand_ids: brandId,
      class2_ids: "70,71",
    };
    // 添加后，请求下一页的数据
    if (searchAfter) {
      params.search_after = searchAfter;
    }
    let res = await apis.cmsCommonArticlesList(params);
    if (res?.returncode === 0 && res.result?.items?.length > 0) {
      const currentInformationList = res.result.items;
      setSearchAfter(res.result.search_after);
      // 点赞数、回复数、查看数获取
      const idList = currentInformationList.map(
        (item: any) =>
          `cms-reply_count-${item.id},cms-like_count-${item.id},cms-pv-${item.id}`
      );
      const reqParams = {
        appid: "app",
        value: idList.join(","),
      };
      const otherInfoList = await apis.getHotData(reqParams);
      if (otherInfoList?.returncode === 0 && otherInfoList.result?.length > 0) {
        const otherInfoResult = otherInfoList.result;
        let newInformationList = currentInformationList.map(
          (informationItem: any, index: number) => {
            return Object.assign(
              { ...informationItem },
              {
                extendReplyCount: otherInfoResult[index * 3]?.count,
                extendLikeCount: otherInfoResult[index * 3 + 1]?.count,
                extendPv: otherInfoResult[index * 3 + 2]?.count,
              }
            );
          }
        );
        setInformationList(informationList.concat(newInformationList));
      } else {
        setInformationList(informationList.concat(currentInformationList));
      }
    }
  };

  // 获取品牌新闻数据
  const getNewsList = async () => {
    let res = await apis.getArticlesCommon({
      appid: "app",
      pageIndex: newsPageIndex + 1,
      pageSize: 5,
      brandIds: brandId,
      contentAttribution: 1,
    });
    if (res?.returncode === 0 && res.result?.items?.length > 0) {
      const currentNewsList = res.result.items;
      // 点赞数、回复数、查看数获取
      const idList = currentNewsList.map(
        (item: any) =>
          `cms-reply_count-${item.id},cms-like_count-${item.id},cms-pv-${item.id}`
      );
      const reqParams = {
        appid: "app",
        value: idList.join(","),
      };
      const otherInfoList = await apis.getHotData(reqParams);
      if (otherInfoList?.returncode === 0 && otherInfoList.result?.length > 0) {
        const otherInfoResult = otherInfoList.result;
        let newNewsList = currentNewsList.map(
          (newsItem: any, index: number) => {
            return Object.assign(
              { ...newsItem },
              {
                extendReplyCount: otherInfoResult[index * 3]?.count,
                extendLikeCount: otherInfoResult[index * 3 + 1]?.count,
                extendPv: otherInfoResult[index * 3 + 2]?.count,
              }
            );
          }
        );
        setNewsList(newsList.concat(newNewsList));
      } else {
        setNewsList(newsList.concat(currentNewsList));
      }
    }
  };

  const addZero = (time: any) => {
    if (time >= 0 && time <= 9) {
      return `0${time}`;
    }
    return time;
  };

  const jumpPage = (url: any) => {
    if (!url) {
      return;
    }
    window.location.href = url;
  };

  // 格式化时间
  const dateFormat = ({ time, type }: any) => {
    if (!time) {
      return "";
    }
    if (type === "information") {
      return time.split(" ")[0].replace(/\//g, "-");
    } else {
      let date = new Date(+time.slice(6, -2));
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      return `${date.getFullYear()}-${addZero(month)}-${addZero(strDate)}`;
    }
  };

  const getNextPageList = () => {
    //文档内容实际高度（包括超出视窗的溢出部分）
    var scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    //滚动条滚动距离
    var scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    //窗口可视范围高度
    var clientHeight =
      window.innerHeight ||
      Math.min(
        document.documentElement.clientHeight,
        document.body.clientHeight
      );

    if (clientHeight + scrollTop >= scrollHeight - 50) {
      if (currentTab === 0) {
        // 最多展示30条数据
        if (informationList?.length >= 30) {
          return;
        }
        let newInformationPageIndex = informationPageIndex + 1;
        setInformationPageIndex(newInformationPageIndex);
      } else {
        // 最多展示30条数据
        if (newsList?.length >= 30) {
          return;
        }
        setNewsPageIndex(newsPageIndex + 1);
      }
    }
  };

  const throttleGetNextPageList = useThrottle(getNextPageList, 100);

  window.onscroll = () => {
    throttleGetNextPageList();
  };

  useEffect(() => {
    if (!brandId) {
      return;
    }
    getInformationList();
  }, [brandId, informationPageIndex]);

  useEffect(() => {
    if (!brandId) {
      return;
    }
    getNewsList();
  }, [brandId, newsPageIndex]);

  return (
    <div className={style["news-wrap"]}>
      <div className={style["news-tab"]}>
        {tabs.map((tabItem, index) => {
          return (
            <div
              className={
                style["news-tab-item"] +
                ` ${currentTab === index ? style["news-tab-item-active"] : ""}`
              }
              onClick={() => {
                setCurrentTab(index);
              }}
              key={index}
            >
              {tabItem}
            </div>
          );
        })}
      </div>

      {currentTab === 0 ? (
        <div className={style["information-content-wrap"]}>
          {informationList?.length > 0
            ? informationList.map((informationItem: any, index: any) => {
                return (
                  <div
                    className={style["information-item"]}
                    key={index}
                    onClick={() => {
                      jumpPage(informationItem.pc_url);
                    }}
                  >
                    <div className={style["title"]}>
                      {informationItem.title}
                    </div>
                    <img
                      src={informationItem.img_url}
                      alt=""
                      className={style["information-pic"]}
                    />
                    <div className={style["other-info-wrap"]}>
                      <div className={style["other-info-left"]}>
                        <span className={style["author"]}>
                          {informationItem.author_name}
                        </span>
                        <span className={style["time"]}>
                          {dateFormat({
                            time: informationItem.publish_time,
                            type: "information",
                          })}
                        </span>
                      </div>
                      <div className={style["other-info-right"]}>
                        <div className={style["replay-count"]}>
                          <i className={style["replay-icon"]}></i>
                          <span>
                            {informationItem.extendReplyCount >= 0
                              ? informationItem.extendReplyCount
                              : 0}
                          </span>
                        </div>
                        <div className={style["like-count"]}>
                          <i className={style["like-icon"]}></i>
                          <span>
                            {informationItem.extendLikeCount >= 0
                              ? informationItem.extendLikeCount
                              : 0}
                          </span>
                        </div>
                        <div className={style["pv-count"]}>
                          <i className={style["pv-icon"]}></i>
                          <span>
                            {informationItem.extendPv >= 0
                              ? informationItem.extendPv
                              : 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      ) : (
        <div className={style["news-content-wrap"]}>
          {newsList?.length > 0
            ? newsList.map((newsItem: any, index: any) => {
                return (
                  <div
                    className={style["information-item"]}
                    key={index}
                    onClick={() => {
                      jumpPage(newsItem.pclink);
                    }}
                  >
                    <div className={style["title"]}>{newsItem.title}</div>
                    <img
                      src={newsItem.img}
                      alt=""
                      className={style["information-pic"]}
                    />
                    <div className={style["other-info-wrap"]}>
                      <div className={style["other-info-left"]}>
                        <span className={style["author"]}>
                          {newsItem.editorname}
                        </span>
                        <span className={style["time"]}>
                          {dateFormat({
                            time: newsItem.publishtime,
                            type: "news",
                          })}
                        </span>
                      </div>
                      <div className={style["other-info-right"]}>
                        <div className={style["replay-count"]}>
                          <i className={style["replay-icon"]}></i>
                          <span>
                            {newsItem.extendReplyCount >= 0
                              ? newsItem.extendReplyCount
                              : 0}
                          </span>
                        </div>
                        <div className={style["like-count"]}>
                          <i className={style["like-icon"]}></i>
                          <span>
                            {newsItem.extendLikeCount >= 0
                              ? newsItem.extendLikeCount
                              : 0}
                          </span>
                        </div>
                        <div className={style["pv-count"]}>
                          <i className={style["pv-icon"]}></i>
                          <span>
                            {newsItem.extendPv >= 0 ? newsItem.extendPv : 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      )}
    </div>
  );
}
